/**
 * PlansRouter — Decide entre a página de planos legada e a nova (integracao_v1)
 *
 * Quando o tenant tem `tenant_billing_bindings` ativo cujo plano está em
 * `billing_integration='integracao_v1'`, renderiza a nova PlansV2.
 * Caso contrário, mantém a página atual (legada).
 */
import { lazy, Suspense } from "react";
import { Loader2 } from "lucide-react";
import { useTenantPlansViewMode } from "@/hooks/tenant/useTenantPlansV2";

const LegacyPlans = lazy(() => import("./Plans"));
// V1: novo hub "Minha assinatura" com 3 abas (visão geral, faturas, catálogo).
// A PlansV2 antiga continua existindo e é consumida internamente pelo
// CatalogTab do hub — não é mais montada diretamente pelo router.
const BillingHub = lazy(() => import("./billing/BillingHub"));

export default function PlansRouter() {
  const { data: mode, isLoading } = useTenantPlansViewMode();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>);

  }

  return (
    <Suspense
      fallback={
      <div className="flex items-center justify-center min-h-[60vh]">
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        </div>
      }>

      {mode === "integracao_v1" ? <BillingHub /> : <LegacyPlans />}
    </Suspense>);

}
